import { render, staticRenderFns } from "./wordchanger.vue?vue&type=template&id=1f854887&"
import script from "./wordchanger.vue?vue&type=script&lang=js&"
export * from "./wordchanger.vue?vue&type=script&lang=js&"
import style0 from "./wordchanger.vue?vue&type=style&index=0&id=1f854887&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports